'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var cn = exports.cn = function cn(className) {
    return typeof className === 'string' ? className.split('.').join(' ').trim() : '';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-id-swiper/lib/utils.js
// module id = 1231
// module chunks = 2